import React, {useEffect, useState} from 'react';
import { Link } from 'react-router-dom';
import { getFarmInspectionById, getFarmInspectionVisitsByInspectionId } from "../../api/web";
import moment from "moment";

const FarmInspectionDetail = (props) => {

    const id = props.match.params.id;
    const inspectionId = parseInt(id, 10);
    const [initialLoading, setInitialLoading] = useState(true);
    const [inspection, setInspection] = useState(null);
    const [visits, setVisits] = useState([]);
    const [visitsLoading, setVisitsLoading] = useState(false);

    useEffect(() => {
        getFarmInspectionById(id).then((response) => {
            if (!response.error) {
                setInspection(response.payload);
            }
            setInitialLoading(false);
        });
    }, [id]);

    useEffect(() => {
        if (!inspection || !inspectionId) return;
        setVisitsLoading(true);
        getFarmInspectionVisitsByInspectionId(inspectionId).then((res) => {
            if (!res.error && Array.isArray(res.payload)) {
                setVisits(res.payload);
            } else {
                setVisits([]);
            }
            setVisitsLoading(false);
        });
    }, [inspection, inspectionId]);

    const personDisplay = (obj) => {
        if (!obj) return '—';
        if (typeof obj === 'object') {
            const n = [obj.first_name, obj.last_name].filter(Boolean).join(' ');
            return n || obj.username || obj.id || '—';
        }
        return `#${obj}`;
    };

    if (initialLoading) {
        return (
            <div className="content-body">
                <div className="container d-flex justify-content-center ht-100p">
                    <div className="d-flex flex-column align-items-center justify-content-center">
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                        <p className="mg-t-10">Loading farm inspection</p>
                    </div>
                </div>
            </div>
        );
    }

    if (!inspection) {
        return (
            <div className="content-body">
                <div className="container pd-x-0">
                    <div className="mg-b-20">
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/farm">Farms</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Inspection not found</li>
                            </ol>
                        </nav>
                        <p className="tx-danger">Farm inspection not found.</p>
                        <Link to="/farm" className="btn btn-sm btn-primary">Back to Farms</Link>
                    </div>
                </div>
            </div>
        );
    }

    const farmId = inspection.farm?.id ?? inspection.farm;
    const farmName = inspection.farm?.name ?? '—';

    return (
        <div className="content-body">
            <div className="container pd-x-0">
                <div className="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb breadcrumb-style1 mg-b-10">
                                <li className="breadcrumb-item"><Link to="/dashboard">Menu</Link></li>
                                <li className="breadcrumb-item"><Link to="/farm">Farms</Link></li>
                                {farmId != null && (
                                    <li className="breadcrumb-item"><Link to={`/farm/${farmId}`}>Farm #{farmId}</Link></li>
                                )}
                                <li className="breadcrumb-item active" aria-current="page">Inspection #{inspection.id}</li>
                            </ol>
                        </nav>
                        <h4 className="mg-b-5 tx-spacing--1">Farm Inspection #{inspection.id}</h4>
                        <div className="d-flex flex-wrap align-items-center gap-2">
                            <span className="tx-color-03 tx-13">{inspection.title ?? '—'} · {farmName}</span>
                        </div>
                    </div>
                    <div className="d-none d-md-block">
                        {farmId != null ? (
                            <Link to={`/farm/${farmId}`} className="btn btn-sm pd-x-15 btn-secondary btn-uppercase">
                                <i className="wd-10 mg-r-5 fa fa-arrow-left"></i> Back to farm
                            </Link>
                        ) : (
                            <Link to="/farm" className="btn btn-sm pd-x-15 btn-secondary btn-uppercase">
                                <i className="wd-10 mg-r-5 fa fa-arrow-left"></i> Back to Farms
                            </Link>
                        )}
                    </div>
                </div>

                <div className="row row-xs">
                    <div className="col-md-12 mg-t-10">
                        <div className="nav-wrapper mg-b-20 tx-13">
                            <ul className="nav nav-line nav-fill tx-medium">
                                <li className="nav-item">
                                    <a href="#info" className="nav-link active" data-bs-toggle="tab">
                                        <i className="ion-md-information-circle"/> Information
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="#visits" className="nav-link" data-bs-toggle="tab">
                                        <i className="ion-md-walk"/> Farm Visits ({visits.length})
                                    </a>
                                </li>
                            </ul>
                        </div>

                        <div className="tab-content">
                            <div id="info" className="tab-pane fade active show">
                                <div className="card">
                                    <div className="card-body">
                                        <div className="row row-sm">
                                            <div className="col-md-6">
                                                <p><strong>Farm:</strong>{' '}
                                                    {farmId != null ? (
                                                        <Link to={`/farm/${farmId}`}>{farmName} (#{farmId})</Link>
                                                    ) : (
                                                        farmName
                                                    )}
                                                </p>
                                                <p><strong>Title:</strong> {inspection.title ?? '—'}</p>
                                                <p><strong>Season:</strong> {inspection.season ?? '—'}</p>
                                                <p><strong>Active:</strong> {inspection.active ? 'Yes' : 'No'}</p>
                                                <p><strong>Verified:</strong> {inspection.verified ? 'Yes' : 'No'}</p>
                                                <p><strong>Created by:</strong> {personDisplay(inspection.created_by)}</p>
                                                <p><strong>Date created:</strong> {inspection.date_created ? moment(inspection.date_created).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                            </div>
                                            <div className="col-md-6">
                                                <p><strong>Date modified:</strong> {inspection.date_modified ? moment(inspection.date_modified).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                <p><strong>End date:</strong> {inspection.end_date ? moment(inspection.end_date).format("Do MMM, YYYY HH:mm") : '—'}</p>
                                                {inspection.description ? (
                                                    <p><strong>Description:</strong><br/><span className="tx-color-03">{inspection.description}</span></p>
                                                ) : null}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div id="visits" className="tab-pane fade">
                                <div className="card">
                                    <div className="card-header">
                                        <h6 className="mg-b-0">Farm Visits</h6>
                                    </div>
                                    <div className="card-body">
                                        {visitsLoading ? (
                                            <div className="d-flex align-items-center justify-content-center pd-y-20">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Loading...</span>
                                                </div>
                                                <span className="mg-l-10 tx-13">Loading visits...</span>
                                            </div>
                                        ) : visits.length === 0 ? (
                                            <p className="tx-color-03 mg-b-0">No farm visits for this inspection.</p>
                                        ) : (
                                            <div className="table-responsive">
                                                <table className="table table-bordered table-sm">
                                                    <thead>
                                                        <tr>
                                                            <th>Title</th>
                                                            <th>Agent</th>
                                                            <th>Description</th>
                                                            <th>Comments</th>
                                                            <th>Yield</th>
                                                            <th>Delivered Qty</th>
                                                            <th>Complete</th>
                                                            <th>Verified</th>
                                                            <th>Date Created</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {visits.map((v) => (
                                                            <tr key={v.id}>
                                                                <td>{v.title ?? '—'}</td>
                                                                <td>{personDisplay(v.agent)}</td>
                                                                <td className="tx-color-03" style={{ maxWidth: 200 }}>{v.description ? String(v.description).slice(0, 80) + (v.description.length > 80 ? '…' : '') : '—'}</td>
                                                                <td className="tx-color-03" style={{ maxWidth: 200 }}>{v.comments ? String(v.comments).slice(0, 80) + (v.comments.length > 80 ? '…' : '') : '—'}</td>
                                                                <td>{v.yield_count != null ? Number(v.yield_count).toLocaleString() : '—'}</td>
                                                                <td>{v.delivered_quantity != null ? Number(v.delivered_quantity).toLocaleString() : '—'}</td>
                                                                <td>{v.complete ? 'Yes' : 'No'}</td>
                                                                <td>{v.verified ? 'Yes' : 'No'}</td>
                                                                <td>{v.date_created ? moment(v.date_created).format("Do MMM, YYYY HH:mm") : '—'}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FarmInspectionDetail;
